import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  // URL base para la comunicacion de servicios
  public URL_BASE = environment.baseUrl;

  // URL de login
  public LOGIN_URL = environment.loginUrl;

  // version de la app
  public APP_VERSION = '';

  //URL para realizar la comunicacion con la API de Negofin
  public URL_API_NEGOFIN = environment.urlApiNegofin;

  //URL para realizar la validacion del token
  public URL_VALIDACION_TOKEN = environment.urlValidacionToken;
}
